import type { Locale } from "../../i18n/config";

/** Rubriques éditoriales — libellés dans marketing.blog.categories, couleur
 *  reprise des teintes modules pour la vignette générée de la liste. */
export type BlogCategory = "budget" | "seo" | "technique" | "strategie";

export const BLOG_CATEGORY_COLOR: Record<BlogCategory, string> = {
  budget: "#e8930c",
  seo: "#4CE6B9",
  technique: "#2e7df6",
  strategie: "#e5589b",
};

export interface BlogPost {
  /** Segment d'URL : /blog/<slug>. */
  slug: string;
  /** Rubrique éditoriale, affichée en chip et colorant la vignette. */
  category: BlogCategory;
  /**
   * Langues réellement RÉDIGÉES pour cet article.
   *
   * Un article peut n'exister qu'en français. Les autres langues ne sont alors
   * ni générées, ni déclarées en hreflang, ni listées au sitemap : annoncer à
   * Google une version espagnole qui renvoie 404 est une erreur qu'il remonte
   * dans Search Console.
   */
  locales: Locale[];
  /** Date de publication (ISO court), sert au tri et au sitemap. */
  date: string;
  /** Dernière révision, si l'article a été mis à jour depuis. */
  updated?: string;
  /** Illustration de partage, dans public/blog/. Facultative. */
  cover?: string;
}

/**
 * Articles publiés — SOURCE UNIQUE.
 *
 * Ajouter un article se fait en deux gestes : créer
 * `src/content/blog/<slug>/<locale>.mdx`, puis déclarer l'entrée ici. Sans
 * cette entrée l'article n'est ni listé, ni généré, ni indexé.
 *
 * Le contenu vit en fichiers plutôt qu'en base : il est versionné avec le code,
 * relu en même temps, et les pages restent entièrement statiques. Le module
 * blog de la plateforme, lui, sert les sites CLIENTS et n'a rien à voir.
 */
export const BLOG_POSTS: BlogPost[] = [
  {
    slug: "combien-coute-un-site-web",
    category: "budget",
    locales: ["fr"],
    date: "2026-08-06",
  },
  {
    slug: "etre-trouve-sur-google-commerce-local",
    category: "seo",
    locales: ["fr"],
    date: "2026-08-06",
  },
  {
    slug: "wordpress-ou-site-sur-mesure",
    category: "technique",
    locales: ["fr"],
    date: "2026-08-06",
  },
  {
    slug: "site-web-ou-page-instagram",
    category: "strategie",
    locales: ["fr"],
    date: "2026-08-06",
  },
];

/** Articles disponibles dans une langue, du plus récent au plus ancien. */
export function postsForLocale(locale: string): BlogPost[] {
  return BLOG_POSTS.filter((post) =>
    post.locales.includes(locale as Locale),
  ).sort((a, b) => b.date.localeCompare(a.date));
}

export function postBySlug(slug: string): BlogPost | undefined {
  return BLOG_POSTS.find((post) => post.slug === slug);
}
